import { useMemo } from 'react';
import { SupportPlatform } from '__generated__/graphql';
import { useLocation, useMatches } from 'react-router-dom';
import { useDisplayTimezoneContext } from 'context/displayTimezone.context';
import { buildSupportContextClientInput, SupportContextClientInput } from 'utils/supportContext';

export const useSupportContext = (): SupportContextClientInput => {
  const location = useLocation();
  const matches = useMatches();
  const { resolvedDisplayTimezone } = useDisplayTimezoneContext();

  return useMemo(
    () =>
      buildSupportContextClientInput({
        pathname: location.pathname,
        params: matches[matches.length - 1]?.params ?? {},
        platform: SupportPlatform.Web,
        locale: typeof navigator === 'undefined' ? undefined : navigator.language,
        timezone: resolvedDisplayTimezone,
      }),
    [location.pathname, matches, resolvedDisplayTimezone]
  );
};
